import { render } from "./GroupAction.vue?vue&type=template&id=04a04580&scoped=true"
import script from "./GroupAction.vue?vue&type=script&lang=js"
export * from "./GroupAction.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a04580"]])

export default __exports__